import { render } from "./MultipleChoice.vue?vue&type=template&id=4b061f94&scoped=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"

import "./MultipleChoice.vue?vue&type=style&index=0&id=4b061f94&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b061f94"]])

export default __exports__